import { defineComponent as _defineComponent } from 'vue'
import { PAGINATION_PER_PAGE } from "@/configs/global";
import { computed, ref, withDefaults, watch } from "vue";
import BaseSelect from "@/components-UI/BaseSelect.vue";

interface Props {
    page: number;
    total: number;
    itemsPerPage?: number;
    isShowSelect?: boolean;
    pageSizes?: number[];
    defaultPageSize?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePagination',
  props: {
    page: null,
    total: null,
    itemsPerPage: { default: PAGINATION_PER_PAGE },
    isShowSelect: { type: Boolean },
    pageSizes: { default: () => [50, 100, 200] },
    defaultPageSize: null
  },
  emits: ["update:page", "update-limit"],
  setup(__props: any, { emit }) {

const props = __props as { page: number, total: number, itemsPerPage: number, isShowSelect?: boolean, pageSizes: number[], defaultPageSize?: number }




const showItems = computed(() => props.isShowSelect ? selectValue.value : props.itemsPerPage);

// select
const selectValue = ref(props.defaultPageSize ?? props.itemsPerPage);

watch(() => props.defaultPageSize, (value) => {
    if (value != null) selectValue.value = value;
});

watch(() => props.itemsPerPage, (value) => {
    if (props.defaultPageSize == null) selectValue.value = value;
});

const updateItemsPerPage = (value: number) => {
    selectValue.value = value;
    emit('update-limit', value);
};

// pagination
const getPageSizes = computed(() => {
    return props.pageSizes?.map(size => ({ value: size })) || [];
});

const startForCurrentPage = computed(() => (props.page - 1) * showItems.value);
const endForCurrentPage = computed(() => {
    const sum = startForCurrentPage.value + showItems.value;
    return sum > props.total ? props.total : sum;
});
const totalPages = computed(() => Math.ceil(props.total / showItems.value));

const getItems = computed((): (string | number)[] => {
    const allPages = [...Array(totalPages.value).keys()].map(i => i + 1);

    const setSeparator = () => {
        return allPages.reduce((acc, item, index) => {
            if (index > 0) acc.push('-');
            acc.push(item);
            return acc;
        }, []);
    };

    if (totalPages.value < 7) return setSeparator();

    if (props.page < 3) {
        allPages.splice(3, totalPages.value - 6, '...');
    } else if (props.page > 2 && props.page < 5) {
        allPages.splice(5, totalPages.value - 6, '...');
    } else if (props.page > 4 && props.page < totalPages.value - 3) {
        const insert = ['...', props.page - 1, props.page, props.page + 1, '...'];
        allPages.splice(1, totalPages.value - 2, ...insert);
    } else if (props.page > totalPages.value - 4 && props.page < totalPages.value - 1) {
        allPages.splice(1, totalPages.value - 6, '...');
    } else if (props.page > totalPages.value - 2) {
        allPages.splice(3, totalPages.value - 6, '...');
    }

    return setSeparator();
});


return { __sfc: true,props, emit, showItems, selectValue, updateItemsPerPage, getPageSizes, startForCurrentPage, endForCurrentPage, totalPages, getItems, BaseSelect }
}

})